import styled from "styled-components";

export const Separator = styled.div`
    width: 100%;
    height: 1px;
    background-color: rgba(0, 0, 0, 0.1);
    margin: 10px 0 15px 0;
`;

export const ExpandedContent = styled.div`
    display: flex;
    flex-direction: column;
    width: 100%;
    min-width: 0;
    margin-top: 10px;
    padding-top: 0;
    box-sizing: border-box;

    @media (max-width: 1024px) {
        margin-top: 9px;
    }

    @media (max-width: 850px) {
        margin-top: 8.5px;
    }

    @media (max-width: 768px) {
        margin-top: 8px;
    }

    @media (max-width: 640px) {
        margin-top: 7px;
    }

    @media (max-width: 480px) {
        margin-top: 6px;
    }

    @media (max-width: 414px) {
        margin-top: 5px;
    }

    @media (max-width: 375px) {
        margin-top: 5px;
    }

    @media (max-width: 320px) {
        margin-top: 4px;
    }

    .expanded-section {
        display: flex;
        flex-direction: column;
        gap: 10px;
        margin-bottom: 20px;
        width: 100%;
        min-width: 0;

        @media (max-width: 1024px) {
            gap: 9px;
            margin-bottom: 18px;
        }

        @media (max-width: 850px) {
            gap: 8.5px;
            margin-bottom: 17px;
        }

        @media (max-width: 768px) {
            gap: 8px;
            margin-bottom: 16px;
        }

        @media (max-width: 640px) {
            gap: 7px;
            margin-bottom: 14px;
        }

        @media (max-width: 480px) {
            gap: 6px;
            margin-bottom: 12px;
        }

        @media (max-width: 414px) {
            gap: 5px;
            margin-bottom: 11px;
        }

        @media (max-width: 375px) {
            gap: 4px;
            margin-bottom: 10px;
        }

        @media (max-width: 320px) {
            gap: 3px;
            margin-bottom: 9px;
        }

        &:last-child {
            margin-bottom: 0;
        }
    }

    .section-title {
        font-size: 10px;
        font-weight: 600;
        text-transform: uppercase;
        letter-spacing: 0.05em;
        color: ${(props: any) => props.theme.colors.c64748b};
        margin-bottom: 8px;

        @media (max-width: 1024px) {
            font-size: 9.5px;
            margin-bottom: 7px;
        }

        @media (max-width: 850px) {
            font-size: 9px;
            margin-bottom: 6.5px;
        }

        @media (max-width: 768px) {
            font-size: 9px;
            margin-bottom: 6px;
        }

        @media (max-width: 640px) {
            font-size: 8.5px;
            margin-bottom: 5px;
        }

        @media (max-width: 480px) {
            font-size: 8px;
            margin-bottom: 5px;
        }

        @media (max-width: 414px) {
            font-size: 7px;
            margin-bottom: 4px;
        }

        @media (max-width: 375px) {
            font-size: 7px;
            margin-bottom: 4px;
        }

        @media (max-width: 320px) {
            font-size: 6px;
            margin-bottom: 3px;
        }
    }

    .partes-container {
        display: flex;
        flex-direction: column;
        gap: 20px;
        
        .parte-item {
            &:last-child {
                margin-bottom: 0;
            }
        }
    }

    .anexos-container {
        display: flex;
        flex-direction: column;
        gap: 8px;
    }

    .anexo-item {
        display: flex;
        align-items: center;
        gap: 8px;
        padding: 8px;
        background-color: rgba(0, 0, 0, 0.02);
        border-radius: 6px;
        transition: background-color 0.2s ease;
        width: 100%;
        min-width: 0;
        box-sizing: border-box;

        @media (max-width: 1024px) {
            padding: 7px;
            gap: 7px;
        }

        @media (max-width: 850px) {
            padding: 6.5px;
            gap: 6.5px;
        }

        @media (max-width: 768px) {
            padding: 6px;
            gap: 6px;
        }

        @media (max-width: 640px) {
            padding: 5.5px;
            gap: 5.5px;
        }

        @media (max-width: 480px) {
            padding: 5px;
            gap: 5px;
        }

        @media (max-width: 414px) {
            padding: 4px;
            gap: 4px;
        }

        @media (max-width: 375px) {
            padding: 3.5px;
            gap: 3.5px;
        }

        @media (max-width: 320px) {
            padding: 3px;
            gap: 3px;
        }

        &[data-excluido="true"] {
            background-color: transparent !important;
            
            &:hover {
                background-color: transparent !important;
            }
        }

        &:hover:not([data-excluido="true"]) {
            background-color: rgba(0, 0, 0, 0.05);
        }

        .anexo-icon {
            height: 16px;
            width: 16px;
            color: ${(props: any) => props.theme.colors.c64748b};
            flex-shrink: 0;

            @media (max-width: 1024px) {
                height: 15px;
                width: 15px;
            }

            @media (max-width: 850px) {
                height: 14.5px;
                width: 14.5px;
            }

            @media (max-width: 768px) {
                height: 14px;
                width: 14px;
            }

            @media (max-width: 640px) {
                height: 13px;
                width: 13px;
            }

            @media (max-width: 480px) {
                height: 12px;
                width: 12px;
            }

            @media (max-width: 414px) {
                height: 11px;
                width: 11px;
            }

            @media (max-width: 375px) {
                height: 10px;
                width: 10px;
            }

            @media (max-width: 320px) {
                height: 9px;
                width: 9px;
            }
        }

        .anexo-info {
            flex: 1;
            min-width: 0;

            .anexo-filename {
                font-size: 10px;
                font-weight: 500;
                color: ${({ theme }) => theme.colors.c000000};
                margin: 0;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;

                @media (max-width: 1024px) {
                    font-size: 9.5px;
                }

                @media (max-width: 850px) {
                    font-size: 9px;
                }

                @media (max-width: 768px) {
                    font-size: 9px;
                }

                @media (max-width: 640px) {
                    font-size: 8.5px;
                }

                @media (max-width: 480px) {
                    font-size: 8px;
                }

                @media (max-width: 414px) {
                    font-size: 7px;
                }

                @media (max-width: 375px) {
                    font-size: 7px;
                }

                @media (max-width: 320px) {
                    font-size: 6px;
                }
            }

            .anexo-size {
                font-size: 9px;
                color: ${(props: any) => props.theme.colors.c64748b};
                margin: 0;
                margin-top: 2px;

                @media (max-width: 1024px) {
                    font-size: 8.5px;
                    margin-top: 1.5px;
                }

                @media (max-width: 850px) {
                    font-size: 8px;
                    margin-top: 1.5px;
                }

                @media (max-width: 768px) {
                    font-size: 8px;
                    margin-top: 1px;
                }

                @media (max-width: 640px) {
                    font-size: 7.5px;
                    margin-top: 1px;
                }

                @media (max-width: 480px) {
                    font-size: 7px;
                    margin-top: 0.5px;
                }

                @media (max-width: 414px) {
                    font-size: 6px;
                    margin-top: 0.5px;
                }

                @media (max-width: 375px) {
                    font-size: 6px;
                    margin-top: 0.5px;
                }

                @media (max-width: 320px) {
                    font-size: 5px;
                    margin-top: 0px;
                }
            }
        }

        .anexo-link-button {
            display: flex;
            align-items: center;
            justify-content: center;
            height: 24px;
            width: 24px;
            padding: 0;
            border: none;
            background: transparent;
            cursor: pointer;
            border-radius: 4px;
            flex-shrink: 0;
            transition: background-color 0.2s ease;

            @media (max-width: 1024px) {
                height: 22px;
                width: 22px;
            }

            @media (max-width: 850px) {
                height: 21px;
                width: 21px;
            }

            @media (max-width: 768px) {
                height: 20px;
                width: 20px;
            }

            @media (max-width: 640px) {
                height: 19px;
                width: 19px;
            }

            @media (max-width: 480px) {
                height: 18px;
                width: 18px;
            }

            @media (max-width: 414px) {
                height: 16px;
                width: 16px;
            }

            @media (max-width: 375px) {
                height: 15px;
                width: 15px;
            }

            @media (max-width: 320px) {
                height: 14px;
                width: 14px;
            }

            &:hover {
                background-color: rgba(0, 0, 0, 0.05);
            }

            &:active {
                background-color: rgba(0, 0, 0, 0.1);
            }

            .anexo-link {
                height: 12px;
                width: 12px;
                color: ${(props: any) => props.theme.colors.c64748b};

                @media (max-width: 1024px) {
                    height: 11px;
                    width: 11px;
                }

                @media (max-width: 850px) {
                    height: 10px;
                    width: 10px;
                }

                @media (max-width: 768px) {
                    height: 12px;
                    width: 12px;
                }

                @media (max-width: 640px) {
                    height: 11px;
                    width: 11px;
                }

                @media (max-width: 480px) {
                    height: 10px;
                    width: 10px;
                }

                @media (max-width: 414px) {
                    height: 9px;
                    width: 9px;
                }

                @media (max-width: 375px) {
                    height: 8px;
                    width: 8px;
                }

                @media (max-width: 320px) {
                    height: 7px;
                    width: 7px;
                }
            }
        }
    }

    .email-container {
        border: 1px solid rgba(0, 0, 0, 0.1);
        border-radius: 6px;
        padding: 8px;
        display: flex;
        flex-direction: column;
        gap: 8px;
        width: 100%;
        min-width: 0;
        box-sizing: border-box;

        @media (max-width: 1024px) {
            padding: 7px;
            gap: 7px;
        }

        @media (max-width: 850px) {
            padding: 6.5px;
            gap: 6.5px;
        }

        @media (max-width: 768px) {
            padding: 6px;
            gap: 6px;
            border-radius: 4px;
        }

        @media (max-width: 640px) {
            padding: 5.5px;
            gap: 5.5px;
        }

        @media (max-width: 480px) {
            padding: 5px;
            gap: 5px;
        }

        @media (max-width: 414px) {
            padding: 4px;
            gap: 4px;
        }

        @media (max-width: 375px) {
            padding: 3.5px;
            gap: 3.5px;
        }

        @media (max-width: 320px) {
            padding: 3px;
            gap: 3px;
        }

        .email-detalhes {
            font-size: 12px;
            color: ${(props: any) => props.theme.colors.c64748b};
            margin: 0;
            word-break: break-word;

            @media (max-width: 1024px) {
                font-size: 11.4px;
            }

            @media (max-width: 850px) {
                font-size: 10.8px;
            }

            @media (max-width: 768px) {
                font-size: 10.8px;
            }

            @media (max-width: 640px) {
                font-size: 10.2px;
            }

            @media (max-width: 480px) {
                font-size: 9.6px;
            }

            @media (max-width: 414px) {
                font-size: 8.4px;
            }

            @media (max-width: 375px) {
                font-size: 7.2px;
            }

            @media (max-width: 320px) {
                font-size: 6px;
            }
        }

        @media (min-width: 768px) {
            padding: 12px;
            gap: 8px;
        }
    }
`;

